module.exports = __webpack_public_path__ + "static/media/medal.f184b16c.svg";